import { useEffect, useState } from "react";
import adminApi from "../../lib/adminApi";
import { fmtUsd } from "../../lib/api";
import { Users, Prohibit, Coins, ArrowsDownUp, Briefcase, ChartLineUp, ArrowClockwise } from "@phosphor-icons/react";
import { Button } from "../ui/button";

const Card = ({ icon: Icon, label, value, accent, testid }) => (
  <div className="bg-[#111827] border border-[#1F2937] rounded-xl p-4" data-testid={testid}>
    <div className="flex items-center gap-2 text-[#6B7280] text-xs">
      <Icon size={16} className={accent} />
      <span>{label}</span>
    </div>
    <p className="mt-2 text-2xl font-semibold text-white mono">{value}</p>
  </div>
);

export default function AdminOverview() {
  const [stats, setStats] = useState(null);
  const load = () => adminApi.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
  useEffect(() => { load(); const i = setInterval(load, 8000); return () => clearInterval(i); }, []);

  if (!stats) return <div className="text-[#6B7280] text-sm p-4">Загрузка…</div>;

  return (
    <div data-testid="admin-overview">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-white">Обзор</h2>
        <Button variant="ghost" size="sm" onClick={load} className="text-[#9CA3AF] hover:text-white" data-testid="overview-refresh">
          <ArrowClockwise size={16} className="mr-1" /> Обновить
        </Button>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        <Card icon={Users} label="Всего трейдеров" value={stats.total_users} accent="text-[#E3B341]" testid="stat-total-users" />
        <Card icon={ChartLineUp} label="Активные" value={stats.active_users} accent="text-[#0ECB81]" testid="stat-active-users" />
        <Card icon={Prohibit} label="Заблокированы" value={stats.blocked_users} accent="text-[#F6465D]" testid="stat-blocked-users" />
        <Card icon={Coins} label="Профинансировано" value={stats.funded_users} accent="text-[#E3B341]" testid="stat-funded-users" />
        <Card icon={Coins} label="Сумма балансов" value={`$${fmtUsd(stats.total_balance)}`} accent="text-[#0ECB81]" testid="stat-total-balance" />
        <Card icon={Coins} label="Всего депозитов" value={`$${fmtUsd(stats.total_deposits)}`} accent="text-[#E3B341]" testid="stat-total-deposits" />
        <Card icon={ArrowsDownUp} label="Выводы в ожидании" value={`${stats.pending_withdrawals} · $${fmtUsd(stats.pending_withdrawals_amount)}`} accent="text-[#F6465D]" testid="stat-pending-withdrawals" />
        <Card icon={Briefcase} label="Prop-заявки" value={stats.pending_prop} accent="text-[#E3B341]" testid="stat-pending-prop" />
      </div>
      <div className="mt-3 bg-[#111827] border border-[#1F2937] rounded-xl p-4">
        <div className="flex items-center gap-2 text-[#6B7280] text-xs">
          <ChartLineUp size={16} className="text-[#0ECB81]" />
          <span>Открытые позиции (все трейдеры)</span>
        </div>
        <p className="mt-2 text-2xl font-semibold text-white mono" data-testid="stat-open-positions">{stats.open_positions}</p>
      </div>
    </div>
  );
}
